import { LOAD_STATE } from '@shared/axios';
import { createReducer, INITIAL_STATE } from '@shared/redux';
import { buildPostMobeesFormApiConfig } from './form.api';

export const HANDLE_SUBMIT_MOBEES_FORM = '@billing/details/HANDLE_SUBMIT_MOBEES_FORM';

export const POST_MOBEES_FORM_REQUEST_CALLED = '@billing/details/POST_MOBEES_FORM_REQUEST_CALLED';
export const POST_MOBEES_FORM_REQUEST_SUCCEEDED = '@billing/details/POST_MOBEES_FORM_REQUEST_SUCCEEDED';
export const POST_MOBEES_FORM_REQUEST_FAILED = '@billing/details/POST_MOBEES_FORM_REQUEST_FAILED';

export const SET_MOBEES_FORM_LOAD_STATE = '@mobees/newCampaign/SET_MOBEES_FORM_LOAD_STATE';
export const RESET_MOBEES_FORM = '@mobees/newCampaign/RESET_MOBEES_FORM';

export const getMobeesFormLoadState = state => state.partnerships
    .mobees.newCampaign.form.loadState;

export const setMobeesFormLoadState = loadState => ({
    type: SET_MOBEES_FORM_LOAD_STATE,
    payload: {
        loadState,
    },
});

export const submitMobeesForm = () => ({
    type: HANDLE_SUBMIT_MOBEES_FORM,
    payload: {},
});

export const postMobeesFormRequest = campaignId => ({
    type: POST_MOBEES_FORM_REQUEST_CALLED,
    actionTypes: {
        success: POST_MOBEES_FORM_REQUEST_SUCCEEDED,
        fail: POST_MOBEES_FORM_REQUEST_FAILED,
    },
    config: buildPostMobeesFormApiConfig(campaignId),
});

export const resetMobeesForm = () => ({
    type: RESET_MOBEES_FORM,
    payload: {},
});

const initialState = { loadState: LOAD_STATE.SUCCESS };

export const mobeesFormReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [SET_MOBEES_FORM_LOAD_STATE]: (state, action) => ({
        ...state,
        loadState: action.payload.loadState,
    }),
});
